import React, { useEffect, useState } from "react";
import api from "../services/apiClient";
import AuthService from "../services/authentication";

import { Label } from "../ui";

function SetRrpForm(props) {
  const [defaultRrp, setDefaultRrp] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  let auth = AuthService.useAuth();

  const handleInputChange = () => {
    const value = !defaultRrp;
    setDefaultRrp(value);
  };

  useEffect(() => {
    // Only update server after initial load is complete
    if (isLoaded) {
      updateServer();
    }
  }, [defaultRrp, isLoaded]);

  useEffect(() => {
    api
      .get("/api/practitioner/default-rrp", { headers: auth.authHeader() })
      .then((response) => {
        console.log(response.data);
        setDefaultRrp(response.data);
        setIsLoaded(true);
      })
      .catch((error) => {
        console.log(error);
        setIsLoaded(true); // Set loaded even on error to prevent infinite loading
      });
  }, []);

  const updateServer = () => {
    api
      .post(
        `/api/practitioner/default-rrp`,
        {
          rrp: defaultRrp,
        },
        {
          headers: auth.authHeader(),
        }
      )
      .then((response) => {
        // console.log(response)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <form>
      <Label>Set your default pricing option</Label>
      <Label> </Label>
      <div className="flex items-center gap-2 mb-1">
        <input
          id="rrp-option-rrp"
          onChange={handleInputChange}
          type="radio"
          checked={defaultRrp}
        />
        <Label htmlFor="rrp-option-rrp" className="mb-0">RRP</Label>
      </div>
      <div className="flex items-center gap-2 mb-1">
        <input
          id="rrp-option-markup"
          onChange={handleInputChange}
          type="radio"
          checked={!defaultRrp}
        />
        <Label htmlFor="rrp-option-markup" className="mb-0">Markup</Label>
      </div>
      <p id="passwordHelpBlock" className="text-sm text-gray-500">
        This can be overidden on a per order basis.
      </p>
    </form>
  );
}

export default SetRrpForm;